import { FC } from "react";
import { useParams } from "react-router-dom";
import { useSelector } from "react-redux";
import EventEsaWaveformGraph from "../../../_metronic/partials/widgets/equipmentDashboard/EventEsaWaveformGraph";
import { decodeToken } from "react-jwt";

type params = {
  equipment_name: string;
  equipmentId: string;
  fileId: string;
};

interface AuthState {
  accessToken: string;
}

const EventEsaWaveformWrapper: FC = () => {
  const isAuthorized: string = useSelector<{ auth: AuthState }, string>(
    ({ auth }) => auth.accessToken
  );

  const { equipment_name, equipmentId, fileId } = useParams<params>();

  return (
    <>
      <div className="row gy-5 g-xl-8">
        <div className="col-xxl-12">
          <EventEsaWaveformGraph
            className="mb-5 mb-xl-8"
            equipmentId={equipmentId}
            isAuthorized={isAuthorized}
            fileId={fileId}
            equipment={equipment_name}
          />
        </div>
      </div>
    </>
  );
};

export default EventEsaWaveformWrapper;
